module.exports = __webpack_public_path__ + "07cfa736a064139b67a40cdfe2ffb88a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/superLotion.jpg
 ** module id = 483
 ** module chunks = 0
 **/